import { useMemo } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { List, Typography } from '@mui/material';
import theme from '../../conf/theme';
import { CustomReports } from './CustomReports';
import ReportItem from './ReportItem';
import useCommonNavigations from '../../hooks/Navigation';
import useGmdUserInfo from '../../hooks/gmdUserInfo';

const Reports = () => {
  const userReports = useMemo(() => {
    return CustomReports.filter((x) => x.reportCategory === 'USERREPORT');
  }, []);

  const { userInfo, hasNonSystemClient } = useGmdUserInfo();

  const { goToReport } = useCommonNavigations();

  const onSelectReport = (reportId: string) => goToReport(reportId);

  return (
    <Container fixed>
      {userInfo && (
        <Box p={1} justifyContent="center">
          <Box>
            <Typography
              variant="h2"
              sx={{
                fontSize: theme.typography.pxToRem(25),
                textAlign: 'center',
                fontWeight: 'bold',
                padding: theme.spacing(2),
              }}
            >
              Reports
            </Typography>
          </Box>
          <Box>
            <List
              sx={{
                width: '100%',
                flexGrow: 1,
                backgroundColor: theme.palette.background.paper,
              }}
            >
              {userReports.map((report, index) => (
                <ReportItem
                  key={index}
                  report={report}
                  user={userInfo}
                  hasNonSystemClient={hasNonSystemClient}
                  lastItem={index + 1 < CustomReports.length}
                  onSelectReport={onSelectReport}
                />
              ))}
            </List>
          </Box>
        </Box>
      )}
    </Container>
  );
};

export default Reports;
